import ajax from "./ajax";
const BASE_URL = "/api";
const BASE_URL_TEST = "/test";

//登录
export const reqLogin = params =>
  ajax(`${BASE_URL_TEST}/userLogin/login`, params);
//获取权限
export const reqPermission = prm =>
  ajax(`${BASE_URL}/sys/userinfo`, prm, "POST");
//退出登录
export const reqQuit = params => ajax(`${BASE_URL}/sys/logout`, params, "POST");

//列表查询
export const reqInfoList = params =>
  ajax(`${BASE_URL_TEST}/listByPageWithCondition`, params);
//列表新增
export const reqInfoAdd = params => ajax(`${BASE_URL_TEST}/insert`, params);
//列表更新
export const reqInfoUpdate = params => ajax(`${BASE_URL_TEST}/update`, params);
//列表删除
export const reqInfoDelete = params => ajax(`${BASE_URL_TEST}/delete`, params);
//列表多选删除
export const reqInfoDeleteMutil = params =>
  ajax(`${BASE_URL_TEST}/deleteMutil`, params);
//统计首页素材来源数据排行
export const queryIndexSortList = params =>
  ajax(`${BASE_URL_TEST}/statis/queryIndexSortList`, params);
//统计个人数据
export const personalData = params =>
  ajax(`${BASE_URL_TEST}/statis/personalData`, params);
//统计首页素材增量来源同比
export const incrementSourceContrast = params =>
  ajax(`${BASE_URL_TEST}/statis/incrementSourceContrast`, params);
//查询首页典型数据
export const typicalData = params =>
  ajax(`${BASE_URL_TEST}/statis/typicalData`, params);
//查询首页素材来源比例
export const SourceProportion = params =>
  ajax(`${BASE_URL_TEST}/statis/SourceProportion`, params);

export const queryMoreFileList = params =>
  ajax(`${BASE_URL_TEST}/statis/queryMoreFileList`, params);
